var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductItem'),_c('ServiceItem'),_c('CaseItem'),_c('AboutItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }